import { getScreenSizeIsMobile } from 'app/_utils/general-utils';

export const paths = !getScreenSizeIsMobile() ? {
    alterarSenha: 'alterar-senha',
    esqueciSenha: 'esqueci-senha',
    login: 'login',

    comprador_avaliacoes: 'comprador/avaliacoes',
    comprador_cashback: 'comprador/cashback',
    comprador_conversor: 'comprador/conversor',
    comprador_convidar_vendedor: 'comprador/convidar-vendedor',
    comprador_curador: 'comprador/curador',
    comprador_curador_inconsistencias: 'comprador/curador/inconsistencias',
    comprador_dashboard: 'comprador/visao-geral',
    comprador_dashboard_comprar: 'comprador/visao-geral/comprar',
    comprador_dashboard_detalhe: 'comprador/visao-geral/pedido',
    comprador_dashboard_nova_cotacao: 'comprador/visao-geral/nova-cotacao',
    comprador_dashboard_pecas_canceladas: 'comprador/pecas-canceladas',
    comprador_historico: 'comprador/historico',
    comprador_meus_vendedores: 'comprador/meus-vendedores',
    comprador_pedidos: 'comprador/pedidos',
    comprador_vendedores_convidados: 'comprador/vendedores-convidados',

    gestor_comprador_cashback: 'gestor-comprador/cashback',
    gestor_comprador_visao_geral: 'gestor-comprador/visao-geral',
    gestor_comprador_visao_geral_comprar: 'gestor-comprador/visao-geral/comprar',
    gestor_comprador_visao_geral_pedido: 'gestor-comprador/visao-geral/pedido',
    gestor_comprador_historico: 'gestor-comprador/historico',
    gestor_comprador_holding_config: 'gestor-comprador/holding-config',

    supervisor_comprador_visao_geral: 'supervisor-comprador/visao-geral',
    supervisor_comprador_visao_geral_comprar: 'supervisor-comprador/visao-geral/comprar',
    supervisor_comprador_visao_geral_pedido: 'supervisor-comprador/visao-geral/pedido',
    supervisor_comprador_historico: 'supervisor-comprador/historico',

    gestor_loja_vendedor_cockpit: 'gestor-loja/cockpit',

    gestor_peca_vendedor_atualizar_estoque: 'gestor-peca/atualizar-estoque',
    gestor_peca_vendedor_configurar_cashback: 'gestor-peca/configurar-cashback',
    gestor_peca_vendedor_configurar_fornecimento: 'gestor-peca/painel-vendedores/configurar-fornecimento',
    gestor_peca_vendedor_configurar_rebate: 'gestor-peca/configurar-rebate',
    gestor_peca_vendedor_cockpit: 'gestor-peca/cockpit',
    gestor_peca_vendedor_clientes: 'gestor-peca/clientes',
    gestor_peca_vendedor_gerenciar_vendedores: 'gestor-peca/painel-vendedores/gerenciar-vendedores',
    gestor_peca_vendedor_relatorio_financeiro: 'gestor-peca/relatorio-financeiro',
    gestor_peca_vendedor_vendedores_de_ferias: 'gestor-peca/painel-vendedores/vendedores-de-ferias',

    suporte_cotacoes: 'suporte/cotacoes',
    suporte_gerenciar_vendedores: 'suporte/gerenciar-vendedores',
    suporte_desconectar_usuarios: 'suporte/manutencao/desconectar-usuarios',
    suporte_integracoes: 'suporte/manutencao/integracoes',
    suporte_limpar_tela_vendedor: 'suporte/manutencao/limpar-tela-vendedor',
    suporte_oficina_sem_documentacao: 'suporte/manutencao/oficina-sem-documentacao',
    suporte_usuario_interno: 'suporte/manutencao/usuario/interno',
    suporte_voltar_cotacao: 'suporte/manutencao/voltar-cotacao',

    suporte_faturamento: 'suporte/faturamento',
    suporte_manage_holdings: 'suporte/fornecedores/holdings',

    termos_uso_comprador: 'documentos/termos-uso/oficinas',
    termos_uso_vendedor: 'documentos/termos-uso/fornecedores',

    politica_privacidade_comprador: 'documentos/politica-privacidade/oficinas',
    politica_privacidade_vendedor: 'documentos/politica-privacidade/fornecedores',

    politica_cookies: 'documentos/politica-cookies/plataforma',

    vendedor_dashboard: 'vendedor/visao-geral',
    vendedor_dashboard_confirmar_pedido: 'vendedor/visao-geral/confirmar-pedido',
    vendedor_dashboard_detalhe: 'vendedor/visao-geral/detalhe',
    vendedor_dashboard_responder: 'vendedor/visao-geral/responder',
    vendedor_cockpit: 'vendedor/cockpit',
    vendedor_clientes: 'vendedor/clientes',
    vendedor_notas_fiscais: 'vendedor/notas-fiscais',
    vendedor_pedidos: 'vendedor/pedidos',
    vendedor_commerce: 'vendedor/commerce'
} : {
    alterarSenha: 'alterar-senha',
    esqueciSenha: 'esqueci-senha',
    login: 'login',
    vendedor_dashboard_responder: 'vendedor/visao-geral/responder',
};
